<template>
  <div>
            <v-card-title class="body-2 font-weight-bold">
              TAKAFUL KENDARAAN BERMOTOR - KALKULATOR
            </v-card-title>
            <v-layout>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-money="format"
                    v-model.lazy="form.tsi"
                    ref="tsi"
                    label="Harga Kendaraan  *"
                    class="mx-2"
                    prepend-inner-icon="mdi-cash"
                    required="required"
                    :readonly="form.calculate === true ? true : false"
                    :filled="form.calculate === true ? true : false"
                    @input="GetData('tsi')"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="form.wilayah"
                    label="Nomor Polisi *"
                    class="mx-2"
                    prepend-inner-icon="mdi-menu-down"
                    :prefix="form.plat"
                    required="required"
                    :readonly="true"
                    @click="GetData('platnomor')"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="form.year"
                    label="Tahun Kendaraan *"
                    class="mx-2"
                    prepend-inner-icon="mdi-calendar-month"
                    :suffix="form.age"
                    required="required"
                    @change="GetData('age')"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="form.produk"
                    label="Produk *"
                    class="mx-2"
                    prepend-inner-icon="mdi-clipboard-list-outline"
                    :items="item.produk"
                    item-text="desc"
                    item-value="id"
                    persistent-hint
                    return-object
                    single-line
                    @change="GetData('produk')"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="form.tipe"
                    label="Jenis Kendaraan *"
                    class="mx-2"
                    prepend-inner-icon="mdi-view-list"
                    :items="item.tipe"
                    item-text="desc"
                    item-value="id"
                    persistent-hint
                    return-object
                    single-line
                    @change="GetData('tipe')"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="form.period"
                    label="Periode (Bulan) *"
                    class="mx-2"
                    prepend-inner-icon="mdi-calendar"
                    required="required"
                    @change="GetData('period')"
                  />
                </v-col>
              </v-row>
            </v-layout>
            <template v-if="form.calculate" class="text-center">
              <div class="mx-2">
                <strong>SILAHKAN PILIH COVERAGE *</strong>
                <table
                  class="table table-responsive table-newcustom"
                  width="85%"
                >
                  <thead>
                    <tr>
                      <th></th>
                      <th width="5%">%</th>
                      <th width="10%">RATE</th>
                      <th width="15%">COVERAGE *</th>
                      <th width="12%">TSI</th>
                      <th>KONTRIBUSI</th>
                      <th width="5%">LOADING</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="n in form.number" :key="n">
                      <td>TAHUN - {{ n }}</td>
                      <td>
                        <input
                          type="text"
                          :value="form.depre[n]"
                          class="form-text-readonly text-right"
                          size="5"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          :value="form.rate[n]"
                          class="form-text-readonly text-right"
                          size="10"
                        />
                      </td>
                      <td>
                        <select
                          v-model="form.coverage[n]"
                          class="form-select form-text-combo"
                          @change="Coverage(n)"
                        >
                          <option value="">Please Select</option>
                          <option
                            v-for="row in item.coverage"
                            :value="row"
                            :key="row"
                            >{{ row }}</option
                          >
                        </select>
                      </td>
                      <td>
                        <input
                          type="text"
                          :value="form.detailtsi[n]"
                          v-money="format"
                          class="form-text-numeric text-right"
                          :readonly="true"
                        />
                      </td>

                      <td>
                        <input
                          type="text"
                          :value="form.contribution[n]"
                          class="form-text-readonly text-right"
                          size="35"
                        />
                      </td>

                      <td>
                        <input
                          type="text"
                          :value="form.loading[n]"
                          class="form-text-readonly text-right"
                          size="15"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td colspan="5" class="text-right font-weight-black">
                        TOTAL KONTRIBUSI
                      </td>
                      <td>
                        <input
                          type="text"
                          :value="form.totalcontribution"
                          class="form-text-readonly text-right"
                          size="35"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td colspan="5" class="text-right font-weight-black">
                        LOADING
                      </td>
                      <td>
                        <input
                          type="text"
                          :value="form.totalloading"
                          class="form-text-readonly text-right"
                          size="35"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="5"
                        class="text-right font-weight-black secondary--text"
                      >
                        TOTAL YANG HARUS DIBAYAR
                      </td>
                      <td>
                        <input
                          type="text"
                          :value="form.totalpayment"
                          class="form-text-combo text-right"
                          size="35"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <v-btn
                  depressed
                  small
                  color="primary"
                  @click="ReCalculate()"
                  v-if="form.totalpayment !== 0"
                  >HITUNG ULANG</v-btn
                >
              </div>
            </template>
            <v-bottom-sheet v-model="select.platnomor">
              <v-list class="pt-0">
                <v-subheader class="primary white--text">Plat Nomor</v-subheader>
                <v-text-field
                  v-model="search.platnomor"
                  class="mx-2"
                  prepend-inner-icon="mdi-magnify"
                />
                <div class="scrollable">
                  <v-list-item
                    v-for="row in filter_platnomor"
                    :key="row.gendtab_id"
                    @click="Choose('platnomor', row.gendtab_id, row.gendtab_desc)"
                  >
                    <v-list-item-title class="text-center">{{ row.gendtab_id }}</v-list-item-title>
                  </v-list-item>
                </div>
              </v-list>
            </v-bottom-sheet>
            <v-snackbar
              v-model="snackbar.dialog"
              :color="snackbar.color"
              :timeout="snackbar.timeout"
              rounded="pill"
              bottom
            >
              {{ snackbar.text }}
              <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar.dialog = false">Close</v-btn>
              </template>
            </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "AppPgdCalculator",
  data: () => ({
    form: {
      tsi: 0,
      plat: "B",
      wilayah: "WILAYAH 2",
      year: 0,
      age: "0 Tahun",
      produk: "",
      tipe: "",
      depre: {},
      rate: {},
      coverage: {},
      detailtsi: {},
      contribution: {},
      loading: {},
      period: 0,
      number: 0,
      totalcontribution: 0,
      totalloading: 0,
      totalpayment: 0,
      calculate: false
    },
    item: {
      platnomor: [],
      produk: [
        { id: "CAR", desc: "TAKAFUL MOBIL" },
        { id: "MTR", desc: "TAKAFUL MOTOR" }
      ],
      tipe: [],
      tipecar: [
        { id: "CAR", desc: "MOBIL PENUMPANG" },
        { id: "TRUCK", desc: "TRUCK DAN PICK UP" },
        { id: "BUS", desc: "BUS" }
      ],
      tipemotor: [{ id: "MTR", desc: "SEPEDA MOTOR" }],
      coverage: [],
      coveragecar: ["TLO", "COMPRE"],
      coveragemotor: ["TLO"]
    },
    format: { decimal: ",", thousands: ".", precision: 0 },
    select: { platnomor: false },
    search: { platnomor: "" },
    snackbar: { dialog: false, color: "success", text: "", timeout: 3000 }
  }),
  created() {
    this.form.year = this.$functions.Years();
  },
  computed: {
    filter_platnomor() {
      const query = this.search.platnomor.toLowerCase().trim();
      if (!query) return this.item.platnomor;
      return this.item.platnomor.filter(
        item => item.gendtab_id.toLowerCase().indexOf(query) > -1
      );
    }
  },
  methods: {
    SnackBar(dialog, color, text, timeout) {
      this.snackbar.dialog = dialog;
      this.snackbar.color = color;
      this.snackbar.text = text;
      this.snackbar.timeout = timeout;
    },
    GetData(flag) {
      if (flag === "platnomor") {
        this.search.platnomor = "";
        const formData = new FormData();
        formData.append("gendtab_refid", "V08");
        formData.append("gendtab_actived", "Y");
        formData.append("order_by", "gendtab_id");
        formData.append("order_type", "ASC");
        this.$axios
          .post(this.$functions.SafeURL("apiListGenTableSimple"), formData, {
            headers: { "Content-Type": "multipart/form-data" }
          })
          .then(response => {
            this.select.platnomor = true;
            this.item.platnomor = response.data;
            this.ResetData();
          })
          .catch(error => this.SnackBar(true, "error", error.message, 3000));
      } else if (flag === "age") {
        const age = this.$functions.Years() - Number(this.form.year);
        if (age > 20) {
          alert("Usia kendaraan tidak boleh lebih dari 20 tahun");
          this.form.year = this.$functions.Years();
          this.form.age = "0 Tahun";
        } else {
          this.form.age = `${age} Tahun`;
        }
        this.ResetData();
      } else if (flag === "produk") {
        this.form.tipe = [];
        if (this.form.produk.id === "CAR") {
          this.item.tipe = this.item.tipecar;
          this.item.coverage = this.item.coveragecar;
        } else if (this.form.produk.id === "MTR") {
          this.item.tipe = this.item.tipemotor;
          this.item.coverage = this.item.coveragemotor;
        }
        this.ResetData();
        this.form.calculate = false;
        this.form.period = 0;
      } else if (flag === "tipe") {
        this.ResetData();
      } else if (flag === "period") {
        this.PreparePeriod();
      }
    },
    PreparePeriod() {
      const periodValue = String(this.form.period || "");
      if (periodValue.length !== 2) return;
      this.ResetData();
      const months = Number(periodValue);
      if (months % 12 !== 0 && months !== 18) {
        alert("Periode tidak masuk dalam coverage");
        this.form.period = 0;
        this.ResetData();
        return;
      }
      const period = months === 18 ? 2 : months / 12;
      const tsi =
        Number(this.$functions.ReplaceAllString(this.form.tsi, ".", "")) || 0;
      if (period === 0) {
        alert("Mohon isi periode");
        this.form.period = 0;
        this.form.number = 0;
      } else if (period > 5) {
        alert("Periode tidak boleh lebih dari 5 tahun");
        this.form.period = 0;
        this.form.number = 0;
      } else if (!tsi || !this.form.produk.id || !this.form.tipe.id) {
        alert("Mohon isi harga, produk dan jenis kendaraan");
        this.form.period = 0;
        this.form.number = 0;
      } else {
        this.form.calculate = true;
        this.form.number = period;
        for (let index = 1; index <= period; index += 1) {
          const depreciation = [100, 90, 80, 70, 60][index - 1];
          this.$set(this.form.depre, index, depreciation);
          this.$set(this.form.detailtsi, index, (depreciation * tsi) / 100);
        }
      }
    },
    Coverage(number) {
      this.Calculate(
        number,
        this.form.coverage[number],
        this.form.detailtsi[number]
      );
    },
    ResetData() {
      if (!this.form.calculate) return;
      let period = Number(this.form.period) / 12;
      if (String(this.form.period) === "18") period = 2;
      for (let index = 1; index <= period; index += 1) {
        this.$set(this.form.rate, index, 0);
        this.$set(this.form.contribution, index, 0);
        this.$set(this.form.loading, index, 0);
        this.$set(this.form.coverage, index, "");
      }
      this.form.totalcontribution = 0;
      this.form.totalloading = 0;
      this.form.totalpayment = 0;
    },
    Calculate(number, coverage, tsi) {
      const formData = new FormData();
      formData.append("fastflowrate_category", "VEHICLE");
      formData.append("fastflowrate_id", this.form.tipe.id);
      formData.append("fastflowrate_type", "MAIN");
      formData.append("fastflowrate_tsi", tsi);
      formData.append("fastflowrate_region", this.form.plat);
      formData.append("fastflowrate_period", 1);
      formData.append("fastflowrate_periodunit", "Y");
      formData.append("fastflowrate_cover", coverage);
      this.$axios
        .post(this.$functions.SafeURL("apiListFastFlowRate", ""), formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          if (!response.data.length) return;
          const rate = response.data[0];
          const multiplier =
            String(this.form.period) === "18" && number === 2 ? 0.5 : 1;
          const totalRate = Number(rate.fastflowrate_min) * multiplier;
          const contribution =
            Number(rate.fastflowrate_cont_min) * multiplier;
          this.$set(this.form.rate, number, totalRate);
          this.$set(
            this.form.contribution,
            number,
            this.$functions.FormatNumber(contribution, 0)
          );
          if (this.form.coverage[number] === "COMPRE") {
            const age = this.$functions.Years() - Number(this.form.year) - 5;
            const loading =
              age > 0 ? (age * 0.05 * totalRate * Number(tsi)) / 100 : 0;
            this.$set(
              this.form.loading,
              number,
              loading ? this.$functions.FormatNumber(loading) : 0
            );
          } else {
            this.$set(this.form.loading, number, 0);
          }
          this.SumContribution();
        })
        .catch(error => this.SnackBar(true, "error", error.message, 3000));
    },
    SumContribution() {
      let loading = 0;
      let total = 0;
      for (let index = 1; index <= Number(this.form.number); index += 1) {
        total +=
          Number(
            this.$functions.ReplaceAllString(
              String(this.form.contribution[index] || 0),
              ".",
              ""
            )
          ) || 0;
        loading +=
          Number(
            this.$functions.ReplaceAllString(
              String(this.form.loading[index] || 0),
              ".",
              ""
            )
          ) || 0;
      }
      this.form.totalcontribution = this.$functions.FormatNumber(total);
      this.form.totalloading = this.$functions.FormatNumber(loading);
      this.form.totalpayment = this.$functions.FormatNumber(total + loading);
    },
    Choose(flag, id, desc) {
      if (flag !== "platnomor") return;
      this.form.plat = id;
      this.form.wilayah = desc;
      this.select.platnomor = false;
    },
    ReCalculate() {
      this.ResetData();
      Object.assign(this.form, {
        tsi: 0,
        plat: "B",
        wilayah: "WILAYAH 2",
        year: this.$functions.Years(),
        age: "0 Tahun",
        produk: "",
        tipe: "",
        period: 0,
        calculate: false
      });
    }
  }
};
</script>

